import { FileError } from 'react-dropzone';

export enum UploadFilesModalStatus {
    Ready = 'Ready',
    Uploading = 'Uploading',
    Uploaded = 'Uploaded',
    Error = 'Error',
}

export interface SelectedFilesToUpload {
    file: File;
    status: UploadFilesModalStatus;
    progress: number;
    errors: FileError[] | undefined;
}

export type AudioType = 'music' | 'effect';

export type FileToUploadBase = {
    id: number;
    uniqueId: string;
    name: string;
    aliasName: string;
    expressionName?: string | null;
    imageUrl: string;
    audioType?: AudioType | null;
}

export type FileToUpload = SelectedFilesToUpload & FileToUploadBase;

export interface ManageListCallbacks {
    onDelete?: (fileToUpload: FileToUpload) => void;
}

export enum LibraryType {
    Character = 'character',
    Background = 'background',
    Audio = 'audio',
}
